import React, {useState} from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';
import DayPicker from '../common/DayPicker';
import TimeSlot from './TimeSlot';
import { 
  useGetProviderAvailabilitiesQuery
} from '../../redux/services/providerAvailabilityApi';
import { useGetSchedulesQuery } from '../../redux/services/scheduleApi';
import { getLocationTypes } from '../../helpers/selectOptions';

const PatientSchedulingTimeForm = ({
  providerId,
  serviceCategory,
  lat,
  lon,
  distance = 30,
  onSubmit,
  defaultDate = new Date(),
  includeLocation = false,
}) => {
  const [date, setDate] = useState(defaultDate);
  const [timeSlot, setTimeSlot] = useState(null);
  const [location, setLocation] = useState(null);
  const filter = {
    provider_id: providerId,
    service_category: serviceCategory,
    lat,
    lon,
    day: moment(date).format('ddd').toUpperCase(),
    distance,
    start_minute__gte: 1,
    end_minute__lte: 23 * 60 + 59,
  };
  const paQuery = useGetProviderAvailabilitiesQuery(
    filter, 
    {skip: !providerId || !serviceCategory}
  );
  const availabilities = paQuery?.data?.data || [];
  const slotQuery = useGetSchedulesQuery({
    service_category: serviceCategory,
    day: moment(date).format('ddd').toUpperCase(),
    lat,
    lon,
    distance,
    start_time: moment(date).startOf('day').toISOString(),
    end_time: moment(date).endOf('day').toISOString(),
  }, {});
  console.log('SLOT_QUERY', slotQuery);
  const slots = (slotQuery?.data?.data || []).map(a => ({
    availability_id: a.provider_availability_id,
    start_time: a.start_time,
    end_time: a.end_time,
    provider_availability: a.provider_availability,
  }));
  const selectedAvailability = availabilities
    .find(a => a.id === timeSlot?.availability_id);
  console.log('SELECTED_AVAIL', selectedAvailability);
  const config = (selectedAvailability?.configs || [])
    .find(c => c?.session_type?.service_category === serviceCategory);
  const locationOptions = [
    ...(config?.location_types || []).map(lt => ({
      label: getLocationTypes().find(opt => opt.value === lt)?.label,
      value: lt,
    })),
  ];
  return (
    <Box>
      <Stack spacing={2}>
        <Stack direction='row' alignItems='center' justifyContent='space-between'>
          <IconButton
            size='small'
            color='primary'
            onClick={() => setDate(moment(date).subtract(1, 'week').toDate())}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant='body1' fontWeight={700}>
            {moment(date).startOf('week').format('MMM D')}
            -
            {moment(date).endOf('week').format('MMM D')}
          </Typography>
          <IconButton
            size='small'
            color='primary'
            onClick={() => setDate(moment(date).add(1, 'week').toDate())}
          >
            <ChevronRightIcon />
          </IconButton>
        </Stack>
        <Stack direction='row' alignItems='center' justifyContent='center'>
          <DayPicker 
            date={date} 
            spacing={0.5}
            onChange={(e, date) => setDate(date)}
            availabilities={availabilities} 
            disabledDays={['SAT', 'SUN']}
          />
        </Stack>
      </Stack>
      <Box style={{minHeight: '200px'}} py={4} px={2}>
        <Stack spacing={2}>
          <Stack spacing={1.5}>
            <Typography variant='h3'>Available Times</Typography>
            <Divider />
          </Stack>
          {/* <Stack direction='row' spacing={2} flexWrap='wrap'> */}
          <Grid container gap={1}>
            {slots.map(s => (
              <Grid item key={s.id} md='auto'>
                <TimeSlot
                  key={s.id} 
                  timeSlot={s}
                  selected={timeSlot?.start_time === s.start_time}
                  onClick={(e, _timeSlot) => setTimeSlot(_timeSlot)}
                />
              </Grid>
            ))}
          </Grid>
          {/* </Stack> */}
          {(!slots || slots.length === 0) &&
            <Typography variant='body1' align='center'>
            No times available on the selected date.
            </Typography>
          }
          {!!timeSlot && 
            <Stack spacing={1.5}>
              <Typography variant='h3'>Location</Typography>
              <Divider />
              <ChoiceField
                label={null}
                options={locationOptions}
                onChange={(e, value) => setLocation(value)}
              />
            </Stack>
          }
          <Button
            variant='contained'
            color='primary'
            disabled={!timeSlot}
            onClick={(e) => onSubmit(e, timeSlot, location)}
          >
            Continue
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default PatientSchedulingTimeForm;